import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/**
 * ¿Tiene ESTA empresa la IA guiada por cultivo encendida? (plan cultivos SIEX F7,
 * 05-10-2026; interruptor `platform_settings.pest_crop_ai`.)
 *
 * Encendida: el escáner enseña los chips de ubicación y cultivo, y el triaje la pastilla
 * «Sugerencia de la IA · X · 82 %» cuando el servidor resolvió la plaga. Apagada, la
 * interfaz es EXACTAMENTE la de antes.
 *
 * Se pregunta a la RPC `pest_crop_ai_activo()` (migración 20261006110000), que aplica la
 * MISMA regla que la edge (`_pest_crop_ai_on`, con «all»). Sin la migración, la RPC no
 * existe → error → apagado. Ante la duda (cargando o error), APAGADO.
 */
export function usePestCropAiEnabled() {
  const { company } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: ["pest-crop-ai-activo", company?.id ?? null],
    enabled: !!company?.id,
    queryFn: async (): Promise<boolean> => {
      // La RPC aún no está en los tipos generados (types.ts se regenera al aplicar la migración).
      const sb = supabase as unknown as { rpc: (fn: string) => Promise<{ data: unknown; error: unknown }> };
      const { data, error } = await sb.rpc("pest_crop_ai_activo");
      if (error) return false;
      return data === true;
    },
    staleTime: 5 * 60_000,
  });
  return { on: data === true, loading: isLoading };
}
